import React, { useEffect } from 'react';

export const ManifestsPage: React.FC = () => {
  useEffect(() => {
    const { pathname, search, hash } = window.location;

    window.location.replace(import.meta.env.VITE_MY_FOODA_APP_URL + pathname + search + hash);
  }, []);

  return null;
};

export default ManifestsPage;
